var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{attrs:{"width":"35%","label-col":4,"wrapper-col":14,"visible":_vm.open},on:{"close":_vm.onClose}},[_c('a-divider',{attrs:{"orientation":"left"}},[_c('b',[_vm._v(_vm._s(_vm.formTitle))])]),_c('div',{attrs:{"div":"","id":"playWind"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }